<ng-container *transloco="let t;">
  <app-detail-view [loading]="loading" [messages]="messages" (closed)="onClose()">

    <div title>
      <h1>
        <span *ngIf="newMode()">{{ t('common.labels.create_exercise') }}</span>
        <span *ngIf="editMode()">{{ t('common.labels.exercise') }} <strong>{{ exercise.name }}</strong><i *ngIf="exercise.status === 'inactive'">({{ t('common.deactivated') }})</i></span>
      </h1>
    </div>

    <div details>
      <p-tabView (onChange)="onTabChange($event)" [(activeIndex)]="tabIndex">

          <p-tabPanel header="{{ t('common.labels.basedata') }}" leftIcon="pi pi-sliders-h" [disabled]="isDisabled('basedata')">
              <app-exercise-new *ngIf="newMode()"></app-exercise-new>
              <app-exercise-basedata *ngIf="editMode()" [exercise]="exercise" (setEdit)="setEdit($event)"></app-exercise-basedata>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.exerciseparts') }}" leftIcon="pi pi-sitemap" [disabled]="isDisabled('parts') || exercise === null">
            <app-exercise-parts [(exercise)]="exercise" (setEdit)="setEdit($event)"></app-exercise-parts>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.elements') }}" leftIcon="pi pi-file-o" [disabled]="isDisabled('elements') || exercise === null">
            <app-exercise-elements [(exercise)]="exercise" (setEdit)="setEdit($event)"></app-exercise-elements>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.competences') }}" leftIcon="pi pi-palette" [disabled]="isDisabled('competences') || exercise === null">
              <app-exercise-competences [(exercise)]="exercise" [competences]="competences" (setEdit)="setEdit($event)"></app-exercise-competences>
          </p-tabPanel>

          <p-tabPanel header="{{ t('common.labels.versions') }}" leftIcon="pi pi-clock" [disabled]="isDisabled('versions') || exercise === null">
              <app-exercise-versions [exercise]="exercise"></app-exercise-versions>
          </p-tabPanel>

      </p-tabView>
    </div>

  </app-detail-view>
</ng-container>
